export const Arrow = ({ color , style}) => {
  return (
    <svg
      width="30"
      height="33"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M0.799805 12.4998L11.9998 23.6998M0.799805 12.4998L11.9998 1.2998M0.799805 12.4998L23.1998 12.4998"
        stroke={color}
      />
    </svg>
  )
}
